exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fullPage[data-v-a5eea0f6] {\n  width: 100%;\n  min-height: 100%;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  top: 0;\n}\n\n.how[data-v-a5eea0f6] {\n  width: 7.333333rem;\n  height: 6rem;\n  background-color: #f8f9fa;\n  border-radius: 0.2rem;\n  margin: 4.8rem auto 0 auto;\n}\n\n.tit[data-v-a5eea0f6] {\n  color: #383d48;\n  font-weight: 600;\n  font-size: 0.426667rem;\n  text-align: center;\n  padding-top: 0.6rem;\n}\n\n.content[data-v-a5eea0f6] {\n  width: 5.733333rem;\n  font-size: 0.4rem;\n  text-align: justify;\n  margin: 0.466667rem auto 0 auto;\n  line-height: 0.6rem;\n}\n\n.sure[data-v-a5eea0f6] {\n  color: #2990e7;\n  font-size: 0.426667rem;\n  width: 100%;\n  border-top: 0.026667rem solid #dee6ee;\n  margin-top: 0.6rem;\n  text-align: center;\n  padding-top: 0.266667rem;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-a5eea0f6","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layer/waysLayer.vue
// module id = 262
// module chunks = 6